// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1ZlVH","head":"ProcedureTableInfo_head__mWi04"};